module.exports = __webpack_public_path__ + "img/franchising_help_marketing2.b5e89566.png";